import React, { useState, useEffect, useContext, useCallback } from 'react'
import { AppContext } from 'core/context';
import { Box, Chip, Grid, Link, Paper, Stack, Tooltip, Typography } from '@mui/material';
import NotificationsPausedRoundedIcon from '@mui/icons-material/NotificationsPausedRounded';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { downloadTermConditionFile } from 'services/notifications';
import { fileSaver } from 'utils/common';
import { useSnackbar } from 'notistack';

const notificationTypeArray = [
  {value: 'EVENT', label: 'Event'}, 
  {value: 'FOOD_MENU', label: 'Food Menu'}, 
  {value: 'MESSAGE', label: 'Message'}, 
  {value: 'PAYMENTS', label: 'Payments'}, 
  {value: 'TERMS_AND_CONDITIONS', label: 'Terms and Conditions'}
];

 const settings = {
    infinite: true,
    speed: 1000,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    // pauseOnHover: true,
    adaptiveHeight: true,
  };
  
const Dashboard = () => {

  // const [notification, setNotification] = useState([]);
  const { notices } = useContext(AppContext);

  return notices?.length > 0 ? (
    <>
      <Box sx={{ width: '100%' }}>
        <Grid container  spacing={3} sx={{margin: '0 auto', width: '100%'}}>
          {notices.filter(item => item.files?.length > 0).map((notice, index) => <NotificationCard notice={notice}  key={index} /> )}
        </Grid>
      </Box>
      <Box sx={{ width: '100%' }}>
        <Grid container spacing={3} sx={{margin: '0 auto', width: '100%'}}>
          {notices.filter(item => !item.files || item?.files?.length === 0).map((notice, index) => <NotificationCard notice={notice}  key={index} /> )}
        </Grid>
      </Box>
    </>
  ) : <NoNotifications />
}
 
export default Dashboard;

function NotificationCard({ notice }) {
  const { files=[], noticeType} = notice;

  const [openLightbox, setOpenLightbox] = useState({ status: false, slideIndex: 0 });
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const { enqueueSnackbar } = useSnackbar();

  const imageSlides = files?.map((file) => ({src: `${process.env.REACT_APP_ORIGIN}/rest/notification/${notice.id}/files/${file}`})) || [];

  useEffect(() => {
    if (openLightbox.status) {
      setCurrentSlideIndex(openLightbox.slideIndex);
    }
  }, [openLightbox]);
  
  const showLightbox = useCallback((index) => {
    setOpenLightbox({ status: true, slideIndex: index });
  },[]);

  function downloadTermsDoc(e) {
    e.preventDefault();
    downloadTermConditionFile().then(({response, error}) => {
      // Return if any error
      if(error) return  enqueueSnackbar('File not available', {variant: 'error'});

      const fileName = `Terms&Conditions.${new Date().toISOString().replace(/:/, '.')}.pdf`;
      fileSaver(response, fileName);
    });
  }

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Paper sx={{ p: 2, height: '100%' }} elevation={3}>
        <Stack justifyContent="space-between" spacing={1} alignItems="flex-start">
          <Chip label={ notificationTypeArray.find(({value}) => value === noticeType)?.label || noticeType} size="small" sx={{ color: 'secondary.main' }} />
          {notice?.files?.length > 0 && (
            <Box sx={{ width: '100%', height: 180, overflow: 'hidden', borderRadius: '8px' }}>
              <ImageSlider slides={notice.files} noitificationId={notice.id} showLightbox={showLightbox} />
            </Box>
          )}
          {noticeType === 'TERMS_AND_CONDITIONS' &&
            <Tooltip title="View Document" arrow>
              <Link onClick={downloadTermsDoc} style={{cursor: 'pointer', textDecoration: 'underline'}} >
                Terms and Conditions.pdf
              </Link>
            </Tooltip>
          }
          <Stack direction="row" alignItems="center" justifyContent="flex-start" >
            {noticeType === 'PAYMENTS' && <CurrencyRupeeIcon color="error" sx={{ fontSize: 20, mr: 1 }} />}
            <Typography variant="subtitle" textAlign="start" >
              {notice.message}
            </Typography>
          </Stack>
        </Stack>
      </Paper>
      {imageSlides?.length > 0 &&
        <Lightbox
          open={openLightbox?.status}
          close={() => setOpenLightbox({ status: false, slideIndex: 0 })}
          slides={imageSlides}
          carousel={{
            finite: true,
          }}
          controller={{ closeOnPullDown: true }}
          index={currentSlideIndex}
          render={{
            buttonPrev: imageSlides?.length <= 1 ? () => null : undefined ,
            buttonNext: imageSlides?.length <= 1 ? () => null : undefined,
          }}
        />
      }
    </Grid> 
  )
}

function NoNotifications() {
  return (
    <Paper sx={{ p: 2, maxWidth: 400, margin: '20vh auto' }}>
      <Box alignContent="center" display="flex" justifyContent="center" mb={2}>
        <NotificationsPausedRoundedIcon color="info" sx={{ fontSize: 120 }} />
      </Box> 
      <Typography variant="subtitle1" textAlign="center">
        No new notices
      </Typography>
    </Paper>
  );
}

function ImageSlider({ slides, noitificationId, showLightbox }) {

  return (
    <Slider {...settings}>
      {slides.map((file, idx) => (
        <Box display="flex" height={180}  overflow="hidden" key={idx} onClick={() => showLightbox(idx)}>
          <img src={`${process.env.REACT_APP_ORIGIN}/rest/notification/${noitificationId}/files/${file}`} alt={`Notice ${idx} - File ${idx}`} style={{ width: '100%', height: '180px', objectFit: 'cover', cursor: 'pointer' }} />
        </Box>
      ))}       
    </Slider>
  );
}